import {
    getProfile,
    getActivity,
    getClasses,
    getClassesByDate,
    createProfileClass,
    updateProfileClass,
    getClassesBookers,
    getClassMembers,
    checkInUser,
    checkOutUser,
    getFollowers,
} from './profileRequestConfigs';

class ProfileApi {
    getProfile = getProfile;
    getActivity = getActivity;
    getClasses = getClasses;
    getClassesByDate = getClassesByDate;
    createClass = createProfileClass;
    updateClass = updateProfileClass;
    getClassBookers = getClassesBookers;
    getClassMembers = getClassMembers;
    checkInUser = checkInUser;
    checkOutUser = checkOutUser;
    getFollowrs = getFollowers;
}

class ProfileFactory {
    profile = ProfileApi;
    create() {
        return new this.profile();
    }
}

export const profile = new ProfileFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ProfileApi/index.js